import React, { useState } from "react";
import { Phone, Mail, MapPin, Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";

export default function Contact() {
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const submit = (e) => {
    e.preventDefault();
    // Contact is presentational (mailto) — no third-party API.
    window.location.href = `mailto:olga@equineevolve.com?subject=Enquiry from ${encodeURIComponent(form.name)}&body=${encodeURIComponent(form.message + "\n\n" + form.email)}`;
    setSent(true);
  };

  return (
    <div className="pt-36 pb-28 px-6 md:px-12 lg:px-24 max-w-[1600px] mx-auto">
      <Seo title="Contact Us" description="Get in touch with Equine Evolve — luxury equestrian boutique based in Thurles, Co. Tipperary, Ireland." />
      <Reveal>
        <p className="ee-overline mb-4">Get in touch</p>
        <h1 className="font-display text-5xl md:text-7xl tracking-tight">Contact Us</h1>
      </Reveal>

      <div className="grid lg:grid-cols-2 gap-16 mt-16">
        <Reveal>
          <div className="space-y-8">
            {[
              [Phone, "Call", "+353 87 279 4170"],
              [Mail, "Email", "olga@equineevolve.com"],
              [MapPin, "Visit", "1 Emmett St., Thurles Townparks, Thurles, Co. Tipperary, E41 YH05"],
            ].map(([Icon, label, value]) => (
              <div key={label} className="flex items-start gap-5 border-b ee-hairline pb-8">
                <Icon strokeWidth={1} className="ee-gold-text mt-1" size={26} />
                <div>
                  <p className="ee-overline mb-1">{label}</p>
                  <p className="text-[#FAFAF9] text-lg">{value}</p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <form onSubmit={submit} className="space-y-6" data-testid="contact-form">
            <input
              required
              data-testid="contact-name"
              placeholder="Your name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="w-full bg-transparent border-b ee-hairline focus:border-[#D4AF37] outline-none py-3 text-[#FAFAF9] transition-colors"
            />
            <input
              required
              type="email"
              data-testid="contact-email"
              placeholder="Your email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full bg-transparent border-b ee-hairline focus:border-[#D4AF37] outline-none py-3 text-[#FAFAF9] transition-colors"
            />
            <textarea
              required
              rows={5}
              data-testid="contact-message"
              placeholder="Your message"
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              className="w-full bg-transparent border-b ee-hairline focus:border-[#D4AF37] outline-none py-3 text-[#FAFAF9] transition-colors resize-none"
            />
            <button data-testid="contact-submit" className="bg-[#D4AF37] text-[#0C0A09] px-10 py-4 uppercase tracking-[0.15em] text-sm hover:bg-[#B5952F] transition-colors flex items-center gap-2">
              {sent ? (<><Check size={16} /> Opening email…</>) : "Send Message"}
            </button>
          </form>
        </Reveal>
      </div>
    </div>
  );
}
